import { createContext, useContext } from "react";

/**
 * True while a section is rendered on the present-mode stage (Plan 16). The
 * present overlay already shows the step label + a one-line serif thesis, so
 * each section's own SectionHeader is redundant there and suppresses itself.
 */
export const PresentContext = createContext(false);
export const usePresent = () => useContext(PresentContext);
